import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { Observable } from 'rxjs/Observable';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';

import { DBService } from './db.service';
import { AdminAuthService } from './admin-auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Master Pools Guild';
  loggedIn = false;

  admin: Observable<firebase.User>;

  constructor(
    private afAuth: AngularFireAuth,
    private router: Router,
    private route: ActivatedRoute,
    private dbService: DBService,
    private authService: AdminAuthService
    ) {

    afAuth.authState.subscribe(auth => {
      if (auth == null) {
        this.loggedIn = false;
        this.router.navigate(['login']);
        this.authService.clearAdmin();
      } else {
        this.authService.setAdmin(auth);
        this.router.navigate(['dashboard']);
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts